<template>
  <el-dialog
    append-to-body
    width="500px"
    :title="`${isChange ? '修改' : '创建代理'}`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="100px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="name" label="代理人员">
        <el-input
          placeholder="请输入代理人员姓名"
          v-model="form.data.name"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="account" label="联系电话">
        <el-input
          placeholder="请输入联系电话"
          v-model="form.data.account"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="area" label="代理区域">
        <el-cascader
          v-model="form.data.area"
          :options="areaOptions"
          :props="{ expandTrigger: 'hover', checkStrictly: true }"
          placeholder="请选择代理区域"
          clearable
        ></el-cascader>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import common from "@/util";
export default {
  name: "CompanyAgentEdit",
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          name: "",
          account: "",
          area: [],
        },
        rules: {
          name: [
            { required: true, message: "请输入代理人员姓名", trigger: "blur" },
          ],
          account: [
            { required: true, message: "请输入联系电话", trigger: "blur" },
            {
              pattern: /^1[3-9]\d{9}$/,
              message: "请输入正确的手机号码",
              trigger: "blur",
            },
          ],
          area: [
            { required: true, message: "请选择代理区域", trigger: "change" },
          ],
        },
      },
      areaOptions: [],
    };
  },
  created() {
    this.getArea();
  },
  methods: {
    getArea() {
      this.$http.get("/common/district/all", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.areaOptions = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取详情
    getDetail(row) {
      if (!!row.id) {
        this.isChange = true;
        common.deepClone(this.form.data, row);
        // 处理地区数据
        if (row.area_str) {
          // 如果有地区字符串，需要转换为数组格式
          this.form.data.area = row.area ? row.area.split(",").map(Number) : [];
        }
      }
    },
    reset(done) {
      this.isChange = false;
      if (this.$refs.elFormDom) {
        this.$refs.elFormDom.resetFields();
      }
      this.form.data = {
        name: "",
        account: "",
        area: [],
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if (this.form.data.area.length === 1) {
            this.$message.error("请选择代理市");
            return;
          }
          this.form.loading = true;
          let apiUrl = !this.isChange
            ? "/admin/companyAgent/add"
            : "/admin/companyAgent/add";
          // 将地区数组转换为逗号分隔的字符串
          const params = {
            ...this.form.data,
            province: this.form.data.area[0],
            city: this.form.data.area[1],
            area: this.form.data.area[2] ? this.form.data.area[2] : 0,
          };
          this.$http
            .post(apiUrl, params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success(
                  `${this.isChange ? "修改" : "创建"}成功！`
                );
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>